<script setup>
import {useBaseStore} from "~/stores/base";
import {useWishlistStore} from "~/stores/wishlist";
import {capsuleList, capsuleRemoveProduct, capsuleAddProduct} from "~/api/api.capsule";
import {WISHLIST_TYPE} from "~/utils/constants";
import {wishlistAdd, wishlistDel} from "~/api/api.wishlist";
import ModalWishlistRemoveProductConfirm from "~/components/wishlist/ModalWishlistRemoveProductConfirm.vue";
import {googleTrackLikeProduct} from "~/utils/google-track";

const BNTOMessage = useNuxtApp().$BNTOMessage
const router = useRouter()
const route = useRoute()

/** emits **/
const emits = defineEmits(["create", "like-change", "capsule-add"])

/** props **/
const props = defineProps({
  product: {default: {}},
})

/** data **/
const pageIndex = ref(1)
const pageSize = ref(10)
const isShowModalWishlistRemoveProductConfirm = ref(false)

/** computed **/
const isMobile = computed(() => useBaseStore().getterIsMobile)
const userInfo = computed(() => useBaseStore().getterUserInfo)
const capsuleAll = computed(() => useWishlistStore().getterCapsuleAll)
const capsuleCustom = computed(() => useWishlistStore().getterCapsuleCustom)

/** watch **/

/** methods **/
const getCapsules = async () => {
  async function getData() {
    const res = await capsuleList({pageIndex: pageIndex.value, pageSize: pageSize.value})
    if (res.result.all) useWishlistStore().updateCapsuleAll(res.result.all)
    if (pageIndex.value === 1) {
      useWishlistStore().updateCapsuleCustom(res.result.capsuleList)
    } else {
      useWishlistStore().updateCapsuleCustom(capsuleCustom.value.concat(res.result.capsuleList))
    }
    if (res.result.pageIndex) {
      pageIndex.value = res.result.pageIndex
      await getData()
    }
  }
  await getData()
}
// 总收藏夹 添加
const capsuleAllAddProduct = async () => {
  // 总收藏夹 收藏该商品
  if (capsuleAll.value.isLoading) return
  capsuleAll.value.isLoading = true
  await wishlistAdd({shopProductId: props.product.productId})
  googleTrackLikeProduct(props.product)
  capsuleAll.value.isLoading = false
  useWishlistStore().updateCapsuleAll({
    ...capsuleAll.value,
    productCount: capsuleAll.value.productCount + 1,
    hasProduct: 1,
    shopProductList: [{
      shopProductId: props.product.productId,
      cover: props.product.cover
    }].concat(capsuleAll.value.shopProductList)
  })
  emits("like-change", true)
}
// 总收藏夹 删除
const capsuleAllRemoveProduct = async () => {
  // 从总收藏夹 删除该商品
  if (capsuleAll.value.isLoading) return
  capsuleAll.value.isLoading = true
  await wishlistDel({shopProductId: props.product.productId})
  capsuleAll.value.isLoading = false
  useWishlistStore().updateCapsuleAll({
    ...capsuleAll.value,
    productCount: capsuleAll.value.productCount - 1,
    hasProduct: 0,
    shopProductList: capsuleAll.value.shopProductList.filter(product => product.shopProductId !== props.product.productId)
  })
  emits("like-change", false)

  // 从 每个存在该商品的收藏夹 删除该商品
  useWishlistStore().updateCapsuleCustom(capsuleCustom.value.map(item => {
    if (item.shopProductList.find(product => product.shopProductId === props.product.productId)) {
      item.productCount--
      item.hasProduct = 0
      item.shopProductList = item.shopProductList.filter(product => product.shopProductId !== props.product.productId)
    }
    return item
  }))
}
// 子收藏夹 添加
const capsuleCustomAddProduct = async (capsule) => {
  // 该收藏夹 收藏该商品
  if (capsule.isLoading) return
  capsule.isLoading = true
  await capsuleAddProduct({capsuleId: capsule.capsuleId, shopProductId: props.product.productId})
  capsule.isLoading = false
  useWishlistStore().updateCapsuleCustom(capsuleCustom.value.map(item => {
    /** 在自定义收藏夹中找到当前操作的收藏夹，并将目标商品推入到操作收藏夹的商品数组头部，且修改hasProduct为1 **/
    if (item.capsuleId === capsule.capsuleId) {
      item.productCount++
      item.hasProduct = 1
      item.shopProductList.unshift({shopProductId: props.product.productId, cover: props.product.cover})
    }
    return item
  }))

  // 通知父级该商品加入了该胶囊
  emits("capsule-add", capsule.capsuleId)

  // 若总收藏夹不存在该商品
  if (!capsuleAll.value.shopProductList.find(product => product.shopProductId === props.product.productId)) {
    // 总收藏夹 收藏该商品
    useWishlistStore().updateCapsuleAll({
      ...capsuleAll.value,
      productCount: capsuleAll.value.productCount + 1,
      hasProduct: 1,
      shopProductList: [{
        shopProductId: props.product.productId,
        cover: props.product.cover
      }].concat(capsuleAll.value.shopProductList)
    })
    emits("like-change", true)
  }
}
// 子收藏夹 删除
const capsuleCustomRemoveProduct = async (capsule) => {
  // 从该收藏夹 删除该商品
  if (capsule.isLoading) return
  capsule.isLoading = true
  await capsuleRemoveProduct({capsuleId: capsule.capsuleId, shopProductId: props.product.productId})
  capsule.isLoading = false
  /** 在自定义收藏夹中找到当前操作的收藏夹，并将目标商品 从 操作收藏夹 中删除 的商品数组头部，且修改hasProduct为0 **/
  useWishlistStore().updateCapsuleCustom(capsuleCustom.value.map(item => {
    if (item.capsuleId === capsule.capsuleId) {
      item.productCount--
      item.hasProduct = 0
      item.shopProductList = item.shopProductList.filter(product => product.shopProductId !== props.product.productId)
    }
    return item
  }))
}

const handleLikeClick = async (type, capsule) => {
  switch (type) {
    case WISHLIST_TYPE.ALL:
      if (capsule.shopProductList.find(product => product.shopProductId === props.product.productId)) {
        /** 如果操作商品在某一capsule中，则需要提示 **/
        let isProductInCapsule = false
        for (let i = 0; i < capsuleCustom.value.length; i++) {
          const shopProductList = capsuleCustom.value[i].shopProductList
          if (shopProductList.find(item => item.shopProductId === props.product.productId)) isProductInCapsule = true
        }
        if (isProductInCapsule) return isShowModalWishlistRemoveProductConfirm.value = true
        await capsuleAllRemoveProduct()
      } else {
        await capsuleAllAddProduct()
      }
      break;
    case WISHLIST_TYPE.CUSTOM:
      if (capsule.shopProductList.find(product => product.shopProductId === props.product.productId)) {
        await capsuleCustomRemoveProduct(capsule)
      } else {
        await capsuleCustomAddProduct(capsule)
      }
      break;
  }
}

const handleWishlistRemoveProductConfirm = async () => {
  isShowModalWishlistRemoveProductConfirm.value = false
  await capsuleAllRemoveProduct()
  BNTOMessage.success({title: "removed from wishlist"})
}

/** lifecycle **/
onMounted(() => {
  // 必须由弹窗拉取列表数据，因为有不是从wishlist进入弹窗的case
  getCapsules()
})

</script>

<template>
  <div class="module-choose-capsule-mobile" v-if="isMobile">
    <div class="cell all">
      <div class="cell-left">
        <img
          class="cover"
          v-if="capsuleAll.shopProductList.find(item => item.shopProductId === product.productId)"
          :src="product.cover.url"
          alt="cover"
        >
        <img
          class="cover"
          v-else-if="capsuleAll.shopProductList.length"
          :src="capsuleAll.shopProductList[0].cover.url"
          alt="cover"
        >
        <div v-else class="no-product">
          <img src="@/assets/img/icon-unlike.svg" alt="icon">
        </div>
        <div class="info">
          <div class="name">All</div>
          <div class="item-num">{{ capsuleAll.productCount }} {{ capsuleAll.productCount === 1 ? 'item' : 'items' }}
          </div>
        </div>
      </div>
      <div class="cell-right">
        <div class="like" @click="handleLikeClick(WISHLIST_TYPE.ALL, capsuleAll)">
          <img v-if="capsuleAll.shopProductList.find(item => item.shopProductId === product.productId)" src="@/assets/img/icon-liked.svg" alt="like">
          <img v-else src="@/assets/img/icon-unlike.svg" alt="like">
        </div>
      </div>
    </div>

    <div class="subtitle">
      <div class="left">My Capsules ({{ capsuleCustom.length }})</div>
      <div class="btn-secondary-small" @click="emits('create')">
        <span>create a capsule</span>
      </div>
    </div>

    <template v-if="capsuleCustom.length">
      <div class="cell custom" v-for="(item, index) in capsuleCustom" :key="index">
        <div class="cell-left">
          <img
            class="cover"
            v-if="item.shopProductList.find(findItem => findItem.shopProductId === product.productId)"
            :src="product.cover.url"
            alt="cover"
          >
          <img
            class="cover"
            v-else-if="item.shopProductList.length"
            :src="item.shopProductList[0].cover.url"
            alt="cover"
          >
          <div v-else class="no-product">
            <img src="@/assets/img/icon-unlike.svg" alt="icon">
          </div>
          <div class="info">
            <div class="name">{{ item.capsuleName }}</div>
            <div class="item-num">{{ item.productCount }} {{ item.productCount === 1 ? 'item' : 'items' }}</div>
          </div>
        </div>
        <div class="cell-right">
          <div class="like" @click="handleLikeClick(WISHLIST_TYPE.CUSTOM, item)">
            <img v-if="item.shopProductList.find(findItem => findItem.shopProductId === product.productId)" src="@/assets/img/icon-check.svg" alt="like">
            <img v-else src="@/assets/img/icon-plus.svg" alt="like">
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="no-capsules">
        <img src="@/assets/img/icon-unlike.svg" alt="icon">
        <span>You haven't created a Capsule yet.</span>
      </div>
    </template>
  </div>
  <div class="module-choose-capsule-desktop" v-else>
    <div class="cell all">
      <div class="cell-left">
        <img
          class="cover"
          v-if="capsuleAll.shopProductList.find(item => item.shopProductId === product.productId)"
          :src="product.cover.url"
          alt="cover"
        >
        <img
          class="cover"
          v-else-if="capsuleAll.shopProductList.length"
          :src="capsuleAll.shopProductList[0].cover.url"
          alt="cover"
        >
        <div v-else class="no-product">
          <img src="@/assets/img/icon-unlike.svg" alt="icon">
        </div>
        <div class="info">
          <div class="name">All</div>
          <div class="item-num">{{ capsuleAll.productCount }} {{ capsuleAll.productCount === 1 ? 'item' : 'items' }}
          </div>
        </div>
      </div>
      <div class="cell-right">
        <div class="like" @click="handleLikeClick(WISHLIST_TYPE.ALL, capsuleAll)">
          <img v-if="capsuleAll.shopProductList.find(item => item.shopProductId === product.productId)" src="@/assets/img/icon-liked.svg" alt="like">
          <img v-else src="@/assets/img/icon-unlike.svg" alt="like">
        </div>
      </div>
    </div>

    <div class="subtitle">
      <div class="left">My Capsules ({{ capsuleCustom.length }})</div>
      <div class="btn-secondary-small" @click="emits('create')">
        <span>create a capsule</span>
      </div>
    </div>

    <template v-if="capsuleCustom.length">
      <div class="cell custom" v-for="(item, index) in capsuleCustom" :key="index">
        <div class="cell-left">
          <img
            class="cover"
            v-if="item.shopProductList.find(findItem => findItem.shopProductId === product.productId)"
            :src="product.cover.url"
            alt="cover"
          >
          <img
            class="cover"
            v-else-if="item.shopProductList.length"
            :src="item.shopProductList[0].cover.url"
            alt="cover"
          >
          <div v-else class="no-product">
            <img src="@/assets/img/icon-unlike.svg" alt="icon">
          </div>
          <div class="info">
            <div class="name">{{ item.capsuleName }}</div>
            <div class="item-num">{{ item.productCount }} {{ item.productCount === 1 ? 'item' : 'items' }}</div>
          </div>
        </div>
        <div class="cell-right">
          <div class="like" @click="handleLikeClick(WISHLIST_TYPE.CUSTOM, item)">
            <img v-if="item.shopProductList.find(findItem => findItem.shopProductId === product.productId)" src="@/assets/img/icon-check.svg" alt="like">
            <img v-else src="@/assets/img/icon-plus.svg" alt="like">
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="no-capsules">
        <img src="@/assets/img/icon-unlike.svg" alt="icon">
        <span>You haven't created a Capsule yet.</span>
      </div>
    </template>
  </div>
  <modal-wishlist-remove-product-confirm
    :open="isShowModalWishlistRemoveProductConfirm"
    @close="isShowModalWishlistRemoveProductConfirm = false"
    @confirm="handleWishlistRemoveProductConfirm"
  />
</template>

<style scoped lang="scss">
@import "src/assets/config";

.module-choose-capsule-mobile {
  height: 100%;
  padding-bottom: 40px;
  position: relative;
  overflow-y: auto;

  .cell {
    border: 0.5px solid $color-BNTO-beige-dark;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;

    padding: 4px 8px 4px 4px;

    .cell-left {
      display: flex;
      align-items: center;
      gap: 8px;

      .cover {
        width: 56px;
        height: 56px;
        object-fit: contain;
      }

      .no-product {
        width: 56px;
        height: 56px;
        background: #B8AFAB29;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .info {
        .name {
          color: $color-gray-800;
          font-family: "TWK Lausanne";
          font-size: 14px;
          font-style: normal;
          font-weight: 300;
          line-height: 18px; /* 128.571% */
          letter-spacing: -0.056px;

          // 单行
          word-break: break-all;
          word-wrap: anywhere;
          display: -webkit-box;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-box-orient: vertical;
          line-clamp: 1;
          -webkit-line-clamp: 1;
        }

        .item-num {
          color: $color-gray-500;
          font-family: "TWK Lausanne";
          font-size: 10px;
          font-style: normal;
          font-weight: 300;
          line-height: 12px; /* 120% */

          margin-top: 4px;
        }
      }
    }

    .cell-right {
      .like {
        cursor: pointer;
        display: flex;

        img {
          width: 24px;
          height: 24px;
        }
      }
    }
  }

  .subtitle {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 16px 0;

    .left {
      color: $color-gray-800;
      font-family: "TWK Lausanne";
      font-size: 14px;
      font-style: normal;
      font-weight: 650;
      line-height: 18px; /* 128.571% */
      letter-spacing: -0.056px;
    }

    .btn-secondary-small {
      padding-left: 8px;
      padding-right: 8px;
      margin-right: 1px;
    }
  }

  .custom {
    margin-bottom: 8px;
  }

  .no-capsules {
    margin-top: 72px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    color: $color-BNTO-beige-dark;
    font-family: "TWK Lausanne";
    font-size: 12px;
    font-style: normal;
    font-weight: 300;
    line-height: 12px; /* 100% */
  }
}

.module-choose-capsule-desktop {
  max-height: 436px;
  padding: 20px 16px 40px 16px;
  overflow-y: auto;

  .cell {
    border: 0.5px solid $color-BNTO-beige-dark;
    display: flex;
    justify-content: space-between;
    align-items: center;

    padding: 4px 8px 4px 4px;

    .cell-left {
      display: flex;
      align-items: center;
      gap: 8px;

      .cover {
        width: 56px;
        height: 56px;
        object-fit: contain;
      }

      .no-product {
        width: 56px;
        height: 56px;
        background: #B8AFAB29;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .info {
        .name {
          color: $color-gray-800;
          font-family: "TWK Lausanne";
          font-size: 14px;
          font-style: normal;
          font-weight: 300;
          line-height: 18px; /* 128.571% */
          letter-spacing: -0.056px;

          // 单行
          word-break: break-all;
          word-wrap: anywhere;
          display: -webkit-box;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-box-orient: vertical;
          line-clamp: 1;
          -webkit-line-clamp: 1;
        }

        .item-num {
          color: $color-gray-500;
          font-family: "TWK Lausanne";
          font-size: 10px;
          font-style: normal;
          font-weight: 300;
          line-height: 12px; /* 120% */

          margin-top: 4px;
        }
      }
    }

    .cell-right {
      .like {
        cursor: pointer;
        display: flex;

        img {
          width: 24px;
          height: 24px;
        }
      }
    }
  }

  .subtitle {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 16px 0;

    .left {
      color: $color-gray-800;
      font-family: "TWK Lausanne";
      font-size: 14px;
      font-style: normal;
      font-weight: 650;
      line-height: 18px; /* 128.571% */
      letter-spacing: -0.056px;
    }

    .btn-secondary-small {
      padding-left: 8px;
      padding-right: 8px;
    }
  }

  .custom {
    margin-bottom: 8px;
  }

  .no-capsules {
    margin-top: 72px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    color: $color-BNTO-beige-dark;
    font-family: "TWK Lausanne";
    font-size: 12px;
    font-style: normal;
    font-weight: 300;
    line-height: 12px; /* 100% */
  }
}
</style>
